import { memo } from "react";
import { ArrangeDock } from "./docks/ArrangeDock";
import { FxDock } from "./docks/FxDock";
import { InstrumentDock } from "./docks/InstrumentDock";
import { RightSidebar } from "./docks/RightSidebar";
import { DslPanel } from "./DslPanel";
import { BounceOverlay } from "./BounceOverlay";
import { StatusBar } from "./StatusBar";
import { TrackerGrid } from "../tracker/TrackerGrid";

/**
 * Main lab layout. Memoized so toolbar/shell class updates do not remount
 * TrackerGrid. Docks subscribe to stores themselves and re-render independently.
 */
function LabBodyImpl() {
  return (
    <>
      <div className="lab-body flex min-h-0 flex-1 items-stretch gap-[0.55rem] overflow-hidden px-[0.85rem] pb-[0.65rem] pt-[0.55rem] max-[720px]:flex-col">
        <InstrumentDock />

        <div className="lab-main flex h-full min-h-0 min-w-0 flex-1 flex-col gap-[0.55rem] overflow-hidden p-0">
          <div className="flex min-h-0 flex-1 flex-col gap-[0.7rem]">
            <DslPanel />

            <section className="lab-panel flex min-h-0 min-w-0 flex-1 flex-col gap-[0.45rem] rounded-md border border-lab-line bg-lab-panel p-[0.65rem]">
              <TrackerGrid />
            </section>
          </div>

          <FxDock />
          <StatusBar />
        </div>

        <RightSidebar />
      </div>

      <BounceOverlay />
    </>
  );
}

export const LabBody = memo(LabBodyImpl, () => true);
